<p-toast key="remotePower"></p-toast>

<div id="remote-power">
  <!-- <p-selectButton [options]="drawopts"  [(ngModel)]="drawoptselected" (onChange)="drawAction($event,1)" ></p-selectButton> -->
  <p-selectButton [options]="doFindOpts" [(ngModel)]="doFindOptsSelected" (onChange)="onFindSelectedClicked($event)">
  </p-selectButton>
  <div *ngIf="doFindOptsSelected === 1" class="form-container">
    <form [formGroup]="remotePowerForm" (ngSubmit)="submitForm()">

      <div class="wrapper2">
        <div *ngIf="systemSizeTypes">
          <h5>Velikost sistema</h5>

          <label class="container" *ngFor="let type of systemSizeTypes; let i = index" [attr.data-index]="i">
            <input type="checkbox" (click)="onSistemTypeSelect(type, i)" [checked]="type.selected">
            <span class="checkmark"></span>
            {{type.opis_velikosti_sistema}}
          </label>

        </div>
        <div>
          <h5>Odjem toplote</h5>
          <label class="container">
            <input type="checkbox" formControlName="minConsumptionArea">
            <span class="checkmark"></span>
            Minimalna gostota odjema na območju [MWh/ha/leto]
            <input formControlName="minConsumptionAreaValue" type="text"
              oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
              *ngIf="this.remotePowerForm.get('minConsumptionArea').value" class="consumption-value">
            <!-- <input [disabled]="true" formControlName="minConsumptionNetworkValue" *ngIf="!this.remotePowerForm.get('minConsumptionNetwork').value" class="consumption-value"> -->
          </label>
          <label class="container">
            <input type="checkbox" formControlName="minConsumptionNetwork">
            <span class="checkmark"></span>
            Minimalna gostota odjema v omrežju [MWh/m/leto]
            <input formControlName="minConsumptionNetworkValue" type="text"
              oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
              *ngIf="this.remotePowerForm.get('minConsumptionNetwork').value" class="consumption-value">
            <!-- <input [disabled]="true" formControlName="minConsumptionAreaValue" *ngIf="!this.remotePowerForm.get('minConsumptionArea').value" class="consumption-value"> -->
          </label>
        </div>

        <div>
          <h5 class="title-container">Prisotnost specifičnih odjemalcev <span
              [style]="{width: '143px', fontSize: '16px'}">Delež skupne rabe toplote [%]</span></h5>


          <label class="container">
            <input type="checkbox" formControlName="isStateBuilding">
            <span class="checkmark"></span>
            <p class="label">Javne stavbe v državni lasti</p>
            <p *ngIf="this.remotePowerForm.get('isStateBuilding').value" class="placeholder"><span>{{
                remotePowerForm.get('consumptionShareStateBuildings').value }}</span>%</p>
            <input *ngIf="this.remotePowerForm.get('isStateBuilding').value"
              formControlName="consumptionShareStateBuildings" type="range" min="0" max="100" id="myRange"
              class="consumption-value slider-value">
          </label>

          <label class="container">
            <input type="checkbox" formControlName="isMunicipality">
            <span class="checkmark"></span>
            <p class="label">Javne stavbe v občinski lasti</p>
            <p *ngIf="this.remotePowerForm.get('isMunicipality').value" class="placeholder"><span>{{
                remotePowerForm.get('consumptionShareMunicipalityBuildings').value }}</span>%</p>
            <input *ngIf="this.remotePowerForm.get('isMunicipality').value"
              formControlName="consumptionShareMunicipalityBuildings" type="range" min="0" max="100" id="myRange"
              class="consumption-value slider-value">
          </label>
          <label class="container">
            <input type="checkbox" formControlName="isProduction">
            <span class="checkmark"></span>
            <p class="label">Proizvodna dejavnost</p>
            <p *ngIf="this.remotePowerForm.get('isProduction').value" class="placeholder"><span>{{
                remotePowerForm.get('consumptionShareProductionBuildings').value }}</span>%</p>
            <input *ngIf="this.remotePowerForm.get('isProduction').value"
              formControlName="consumptionShareProductionBuildings" type="range" min="0" max="100" id="myRange"
              class="consumption-value slider-value">
          </label>
          <label class="container">
            <input type="checkbox" formControlName="isApartments">
            <span class="checkmark"></span>
            <p class="label">Večstanovanjske stavbe (najman 3 stanovanja)</p>
            <p *ngIf="this.remotePowerForm.get('isApartments').value" class="placeholder"><span>{{
                remotePowerForm.get('consumptionShareMultiAppartmentBuildings').value }}</span>%</p>
            <input *ngIf="this.remotePowerForm.get('isApartments').value"
              formControlName="consumptionShareMultiAppartmentBuildings" type="range" min="0" max="100" id="myRange"
              class="consumption-value slider-value">
          </label>
          <label class="container">
            <input type="checkbox" formControlName="isBusiness">
            <span class="checkmark"></span>
            <p class="label">Poslovno-storitvene stavbe</p>
            <p *ngIf="this.remotePowerForm.get('isBusiness').value" class="placeholder"><span>{{
                remotePowerForm.get('consumptionShareBusinessBuildings').value }}</span>%</p>
            <input *ngIf="this.remotePowerForm.get('isBusiness').value"
              formControlName="consumptionShareBusinessBuildings" type="range" min="0" max="100" id="myRange"
              class="consumption-value slider-value">
          </label>
          <label class="container">
            <input type="checkbox" formControlName="isTouristic">
            <span class="checkmark"></span>
            <p class="label">Turistično-nastanitvene stavbe</p>
            <p *ngIf="this.remotePowerForm.get('isTouristic').value" class="placeholder"><span>{{
                remotePowerForm.get('consumptionShareTouristicBuildings').value }}</span>%</p>
            <input *ngIf="this.remotePowerForm.get('isTouristic').value"
              formControlName="consumptionShareTouristicBuildings" type="range" min="0" max="100" id="myRange"
              class="consumption-value slider-value">
          </label>
        </div>

      </div>




      <button class="button" type="submit">Najdi</button>
    </form>
  </div>

  <div *ngIf="doFindOptsSelected === 2" class="form-container">
    <p style="margin-bottom: 10px !important;">
      <p-splitButton *ngIf="status" label="{{status.status_opis}}" appendTo="body" [model]="statusActions"
        styleClass="p-button-secondary"></p-splitButton>
    </p>
    <p-selectButton [options]="drawopts" [(ngModel)]="drawoptselected" (onChange)="drawAction($event,2)">
    </p-selectButton>
  </div>


  <!-- 
  <div *ngIf="(doFindOptsSelected === 2)">
    <p-selectButton [options]="roofTopPowerPlant" [(ngModel)]="selectedRoofTopPowerPlant"
      (onChange)="roofTopPowerPlantMode($event)"></p-selectButton>
    <div *ngIf="(selectedRoofTopPowerPlant === 1)">
    </div>
  </div> -->



</div>